import { ANNOTATION_POSITION, MEDIA_TYPES, PROPERTIES } from './plot-bands.constants';
/**
 * A function that returns the media type based on the publication and whether the chart is a video.
 * @param {boolean} isVideo
 * @param {Property} currentProperty
 * @returns {string} - available media type (VIDEO, DIGITAL_WSJ, DIGITAL_BARRONS)
 */
function getMediaType(isVideo, currentProperty) {
  if (isVideo) return MEDIA_TYPES.VIDEO;
  return currentProperty === PROPERTIES.WSJ ? MEDIA_TYPES.DIGITAL_WSJ : MEDIA_TYPES.DIGITAL_BARRONS;
}
/**
 * A function that returns the annotation position "y" value for the given media type.
 * @param {{isVideo: boolean, isTop: boolean, currentProperty: Property}} options
 * @returns {number} - annotation position "y" value
 */
function getAnnotationPositionValue({ isVideo, isTop, currentProperty }) {
  const mediaType = getMediaType(isVideo, currentProperty);
  return ANNOTATION_POSITION[isTop ? ANNOTATION_POSITION.TOP.KEY : ANNOTATION_POSITION.BOTTOM.KEY]
    .VALUE[mediaType];
}

export { getAnnotationPositionValue };
